import { ChangeDetectionStrategy, Component, DestroyRef, EventEmitter, Input, OnInit, Output, ViewChild, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { DeviceService } from '@frontend/vanilla/core';

import { Promotion } from '../crm-offer-data/crm-offer.model';
import { PromotionStatusButtonWrapperComponent } from '../crm-promotion/promotion-status-button-wrapper.component';
import { StoryContentTrackingService } from './story-content-tracking.service';

@Component({
    selector: 'ms-story-promotion',
    templateUrl: './story-promotion.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [PromotionStatusButtonWrapperComponent],
})
export class StoryPromotionComponent implements OnInit {
    private deviceService = inject(DeviceService);
    private storyContentTrackingService = inject(StoryContentTrackingService);

    @Input() promotion: Promotion;
    @Input() storyTitle: string;

    @Output() detailsPopupChange = new EventEmitter<boolean>();

    @ViewChild(PromotionStatusButtonWrapperComponent) promotionStatusButtonWrapperRef: PromotionStatusButtonWrapperComponent;

    private readonly destroyRef = inject(DestroyRef);

    ngOnInit(): void {
        this.deviceService.orientation.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => {
            if (this.deviceService.currentOrientation === 'landscape') {
                this.promotionStatusButtonWrapperRef?.closeDialog();
            }
        });
    }

    getDetailsPopupChange(popupOpen: boolean): void {
        this.detailsPopupChange.emit(popupOpen);
    }

    optInButtonClicked(): void {
        const promotionName = `promotion_${this.promotion.id}`;
        this.storyContentTrackingService.trackOptInClick(promotionName, this.storyTitle);
    }
}
